import React from 'react';

const LoadingState = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
      {[1, 2, 3, 4, 5, 6]?.map((item) => (
        <div
          key={item}
          className="bg-card rounded-lg shadow-warm border border-border overflow-hidden animate-pulse"
        >
          <div className="h-48 md:h-56 lg:h-64 bg-muted" />
          <div className="p-4 md:p-6 space-y-4">
            <div className="flex items-start gap-3">
              <div className="w-12 h-12 md:w-14 md:h-14 bg-muted rounded-lg" />
              <div className="flex-1 space-y-2">
                <div className="h-5 bg-muted rounded w-3/4" />
                <div className="h-4 bg-muted rounded w-1/2" />
              </div>
            </div>
            <div className="space-y-2">
              <div className="h-4 bg-muted rounded w-full" />
              <div className="h-4 bg-muted rounded w-full" />
              <div className="h-4 bg-muted rounded w-2/3" />
            </div>
            <div className="h-10 bg-muted rounded" />
            <div className="flex gap-2">
              <div className="h-9 bg-muted rounded flex-1" />
              <div className="h-9 bg-muted rounded flex-1" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LoadingState;